<template>
  <div class="eventMessage">
    <div class="title">
      事项信息
    </div>
    <div class="noshow" style="margin-top:20px" v-show="!showVisible">
      <a-descriptions bordered :column="2">
        <a-descriptions-item :span="2">
          <template slot="label">
          </template>
          <span style="font-size: 18px;color: #333333;font-weight:bold">基本信息</span>
        </a-descriptions-item>
        <a-descriptions-item label="事项名称">
          {{ itemInfoBean.itemName ? itemInfoBean.itemName : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="基本编码">
          {{ itemInfoBean.baseCode ? itemInfoBean.baseCode : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="事项类型">
          {{ itemInfoBean.itemType ? itemInfoBean.itemType : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="权力来源">
          {{ itemInfoBean.taskPowerSource ? itemInfoBean.taskPowerSource : '--' }}
        </a-descriptions-item>
      </a-descriptions>
      <div style="border: 1px solid #e8e8e8;border-top: 0px;border-radius: 2px;text-align: center;height: 54px;line-height: 54px;margin-top: -1px;z-index: 999;">
        <a @click="showAll(true)">查看全部 ∨</a>
      </div>
    </div>
    <div class="baseMessage" style="margin-top:20px" v-show="showVisible">
      <a-descriptions bordered :column="2">
        <a-descriptions-item :span="2">
          <template slot="label">
          </template>
          <span style="font-size: 18px;color: #333333;font-weight:bold">基本信息</span>
        </a-descriptions-item>
        <a-descriptions-item label="事项名称">
          {{ itemInfoBean.itemName ? itemInfoBean.itemName : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="基本编码">
          {{ itemInfoBean.baseCode ? itemInfoBean.baseCode : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="事项类型">
          {{ itemInfoBean.itemType ? itemInfoBean.itemType : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="权力来源">
          {{ itemInfoBean.taskPowerSource ? itemInfoBean.taskPowerSource : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="行使层级">
          {{ itemInfoBean.useLevel ? itemInfoBean.useLevel : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="实施编码">
          {{ itemInfoBean.taskCode ? itemInfoBean.taskCode : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="到办事现场次数">
          {{ itemInfoBean.taskHandleNum ? itemInfoBean.taskHandleNum : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="必须现场办理原因说明">
          {{ itemInfoBean.taskSceneReason ? itemInfoBean.taskSceneReason : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="事项状态">在用</a-descriptions-item>
        <a-descriptions-item label="事项版本">
          {{ itemInfoBean.taskVersion ? itemInfoBean.taskVersion : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="实施主体">
          {{ itemInfoBean.deptName ? itemInfoBean.deptName : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="实施主体性质">
          {{ itemInfoBean.taskNature ? itemInfoBean.taskNature : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="实施主体编码">
          {{ itemInfoBean.deptCode ? itemInfoBean.deptCode : '--' }}
        </a-descriptions-item>
      </a-descriptions>
    </div>
    <div class="acceptance" style="margin-top:40px;" v-show="showVisible">
      <a-descriptions bordered :column="2">
        <a-descriptions-item :span="2">
          <template slot="label">
          </template>
          <span style="font-size: 18px;color: #333333;font-weight:bold"> 受理标准</span>
        </a-descriptions-item>
        <a-descriptions-item label="是否收费" :span="itemInfoBean.taskCharge === 'yes' ? 1 : 2">
          {{ itemInfoBean.taskCharge ? itemInfoBean.taskCharge === 'yes' ? '收费' : '不收费' : '--' }}
        </a-descriptions-item>
        <!-- <a-descriptions-item label="收费标准" :span="1">
          {{ itemInfoBean.deptCode }}
        </a-descriptions-item> -->
        <a-descriptions-item label="收费依据" v-if="itemInfoBean.taskCharge === 'yes'">
          {{ itemInfoBean.taskChargeBasis ? itemInfoBean.taskChargeBasis : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="办件类型">
          {{ itemInfoBean.taskType ? itemInfoBean.taskType : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="办理形式">
          {{ taskHandleType ? taskHandleType : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="特别程序" :span="2">
          {{ itemInfoBean.taskSpecProcedure ? itemInfoBean.taskSpecProcedure : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="移动端是否对接单点登录">
          {{ itemInfoBean.appIssingleLogin === 'yes' ? '是' : '否' }}
        </a-descriptions-item>
        <a-descriptions-item label="计算机端是否对接单点登录">
          {{ itemInfoBean.isSingleLogin === 'yes' ? '是' : '否' }}
        </a-descriptions-item>
        <a-descriptions-item label="受理条件" :span="2">
          {{ itemInfoBean.taskHandleCondition ? itemInfoBean.taskHandleCondition : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="审批结果类型">
          {{ taskApproveType ? taskApproveType : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="审批结果样本">
          <div v-for="(item, index) in approvalResultEntities" :key="index">
            <a :href="item.taskApproveSampleUrl" target="_blank" v-if="item.taskApproveSampleName">{{ item.taskApproveSampleName }}</a>
            <span v-else>--</span>
          </div>
          <div v-if="approvalResultEntities.length === 0">--</div>
        </a-descriptions-item>
        <a-descriptions-item label="是否支持物流快递">
          {{ itemInfoBean.taskExpressSupport ? itemInfoBean.taskExpressSupport === 'yes' ? '支持' : '不支持' : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="审批结果名称">
          {{ taskApproveName ? taskApproveName : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="是否进驻政务大厅">
          {{ itemInfoBean.taskInhall === 'yes' ? '是' : '否' }}
        </a-descriptions-item>
        <a-descriptions-item label="是否支持网上支付">
          {{ itemInfoBean.taskOnlinePay ? itemInfoBean.taskOnlinePay === 'yes' ? '支持' : '不支持' : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="是否网办" :span="2">
          {{ itemInfoBean.taskOnline === 'yes' ? '是' : '否' }}
        </a-descriptions-item>
      </a-descriptions>
      <div style="border: 1px solid #e8e8e8;border-top: 0px;border-radius: 2px;text-align: center;height: 54px;line-height: 54px;margin-top: -1px;z-index: 999;">
        <a @click="showAll(false)">收起全部 ∧</a>
      </div>
    </div>
  </div>
</template>

<script>
import { jiopAPI } from '@/api/jiopweb/jiop'
export default {
  props: {
    // itemInfoBean: {
    //   type: Object,
    //   // eslint-disable-next-line vue/require-valid-default-prop
    //   default: {}
    // }
  },
  data () {
    return {
      showVisible: false,
      itemInfoBean: [],
      taskHandleType: '',
      taskApproveName: '',
      taskApproveType: '',
      approvalResultEntities: []
    }
  },
  watch: {
    itemInfoBean: {
      deep: true,
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal.iid) {
          this.findOptionList('itemType,powerSources,exerciseLevel,natureSubject,officeType,processingForm,approvalResultType,serviceObject')
        }
      }
    }

  },
  methods: {
    // 查询维度数据
    findOptionList (paramter) {
      this.approvalResultEntities = this.itemInfoBean.approvalResultEntities || []
      let nameString = ''
      this.itemInfoBean.approvalResultEntities.forEach(item => {
        if (item.taskApproveName) {
          nameString = nameString + item.taskApproveName + ','
        }
      })
      this.taskApproveName = nameString.substring(0, nameString.length - 1)
      jiopAPI.findOption(Object.assign({ type: paramter })).then(res => {
        if (res.success) {
          if (res.data.data.itemType) {
            res.data.data.itemType.forEach(val => {
              if (this.itemInfoBean.itemType === val.dictionaryCode) {
                this.itemInfoBean.itemType = val.name
              }
            })
          }
          if (res.data.data.powerSources) {
            res.data.data.powerSources.forEach(val => {
              if (this.itemInfoBean.taskPowerSource === val.dictionaryCode) {
                this.itemInfoBean.taskPowerSource = val.name
              }
            })
          }
          if (res.data.data.exerciseLevel) {
            res.data.data.exerciseLevel.forEach(val => {
              if (this.itemInfoBean.useLevel === val.dictionaryCode) {
                this.itemInfoBean.useLevel = val.name
              }
            })
          }
          if (res.data.data.natureSubject) {
            res.data.data.natureSubject.forEach(val => {
              if (this.itemInfoBean.taskNature === val.dictionaryCode) {
                this.itemInfoBean.taskNature = val.name
              }
            })
          }
          if (res.data.data.officeType) {
            res.data.data.officeType.forEach(val => {
              if (this.itemInfoBean.taskType === val.dictionaryCode) {
                this.itemInfoBean.taskType = val.name
              }
            })
          }
          if (res.data.data.processingForm) {
            let typeString = ''
            res.data.data.processingForm.forEach(val => {
              const stringInfo = this.itemInfoBean.taskHandleType // 如果taskHandleType存在多种形式，并用逗号隔开
              const array = stringInfo.split(',')
              const currentArray = array.filter(ele => ele === val.dictionaryCode)
              if (currentArray.length > 0) {
                typeString = typeString + val.name + ','
              }
              this.taskHandleType = typeString.substring(0, typeString.length - 1)
              // if (this.itemInfoBean.taskHandleType === val.dictionaryCode) {
              //   this.itemInfoBean.taskHandleType = val.name
              // }
            })
          }
          if (res.data.data.approvalResultType) {
            let typeString = ''
            let typeToWord = ''
            this.itemInfoBean.approvalResultEntities.forEach(item => {
              if (item.taskApproveType) {
                typeString = typeString + item.taskApproveType + ','
              }
            })
            typeString = typeString.substring(0, typeString.length - 1)
            const array = typeString.split(',')
            res.data.data.approvalResultType.forEach(val => {
              const currentArray = array.filter(ele => ele === val.dictionaryCode)
              if (currentArray.length > 0) {
                typeToWord = typeToWord + val.name + ','
              }
            })
            typeToWord = typeToWord.substring(0, typeToWord.length - 1)
            this.taskApproveType = typeToWord
          }
        }
      })
    },
    showAll (value) {
      this.showVisible = value
    }
  }
}
</script>

<style lang="less" scoped>
.noshow ::v-deep .ant-descriptions-row:first-child th {
  display: none;
}
.baseMessage ::v-deep .ant-descriptions-row:first-child th {
  display: none;
}
.acceptance ::v-deep .ant-descriptions-row:first-child th {
  display: none;
}
.acceptance ::v-deep .ant-descriptions-bordered .ant-descriptions-item-label {
  width: 162px;
}
.baseMessage ::v-deep .ant-descriptions-bordered .ant-descriptions-item-label {
  width: 162px;
}
.noshow ::v-deep .ant-descriptions-bordered .ant-descriptions-item-label {
  width: 162px;
}
// /deep/ .undefined-item-content {
//   width: 280px;
//   padding-top: 13px;
//   padding-bottom: 13px !important;
//   text-align: right;
// }
/deep/ .ant-descriptions-item-content {
    display: table-cell;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    line-height: 1.5;
    width: 200px;
}
.eventMessage {
  width: 800px;
  .title {
    font-size: 22px;
    color: #333333;
    font-weight: 500;
  }
}
</style>
